import { render, staticRenderFns } from "./PersonPictureSet.vue?vue&type=template&id=969d5166"
import script from "./PersonPictureSet.vue?vue&type=script&lang=js"
export * from "./PersonPictureSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports